import { createReducer } from '@ngrx/store';
import { RedirectPolicy } from '../domain/redirect-policy';
import * as Actions from './redirect-policies.actions';

export const featureKey = 'redirectPolicies';

export interface FeatureState {
  redirectPolicies: RedirectPolicy[];
  loading: boolean;
}

export interface RedirectPoliciesState {
  [featureKey]: FeatureState;
}

export const initialState: FeatureState = {
  redirectPolicies: [],
  loading: false,
};

export const reducer = createReducer(
  initialState,
  ...Actions.fetchRedirectPolicies.reduce((state, action) => ({ ...state, redirectPolicies: action.policies })),
  ...Actions.createRedirectPolicy.reduce((state, action) => ({ ...state, redirectPolicies: action.policies })),
  ...Actions.deleteRedirectPolicy.reduce((state, action) => ({ ...state, redirectPolicies: action.policies })),
  ...Actions.updateRedirectPolicy.reduce((state, action) => ({ ...state, redirectPolicies: action.policies }))
);
